<template lang="pug">
  div
    .flex.flex-col(:class="customClasses")
      button(
        v-for="(tab, index) in tabs"
        :key="tab.title"
        :class="activeTab === index ? activeHeaderClasses : headerClasses"
        type="button"
        @click="selectTab(index)"
      )
        div(:class="labelClasses")
          p {{ tab.title }}
          img(
            v-if="tab.imagePath"
            :alt="tab.title"
            :src="require(`../../images/${tab.imagePath}`)"
            class='w-12'
          )
    slot
</template>

<script>
  export default {
    name: 'SwTabs',
    props: {
      customClasses: {
        type: String,
        default: '',
      },
      headerClasses: {
        type: String,
        default: '',
      },
      activeHeaderClasses: {
        type: String,
        default: '',
      },
      labelClasses: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        tabs: [],
        activeTab: 0,
      };
    },
    created () {
      this.tabs = this.$children;
    },
    mounted () {
      this.selectTab(this.activeTab);
    },
    methods: {
      selectTab (selectedIndex) {
        this.activeTab = selectedIndex;
        this.tabs.forEach((tab, index) => {
          tab.active = (index === selectedIndex);
        });
      },
    },
  };
</script>
